import css from './FormDivider.module.css'

const FormDivider = () => {
    return <div className={css.divider} />
}

export default FormDivider
